import React from 'react';
import BarOrderStatus from '../BarOrderStatus/BarOrderStatus';
import {
    JOB_STATUSES_BAR, JOB_STATUSES_TITLE, VIEW_BAR_STATUS, ARTWORK_STATUSES, ARTWORK_STATUSES_TITLE, ARTWORK_TYPES_TITLE,
    PRODUCTS_ADD_COVER, PRODUCTS_FRONT_BACK_COVER, PRODUCTS_FINISHING_FRONT_BACK, PRODUCTS_COLOURS_FRONT_BACK, PRODUCT_BY_BINDING, JOB_STATUSES, WARNING_NOTIFICATIONS,
} from '../../constants';
import './style.scss';


const renderArtworkList = (artworks, props) => {
    const { warningText, JobStatus } = props.jobData;
    return artworks.map((artwork, index) => {
        return (
            <div className="row job mb-3" key={index} onClick={() => { props.onChangeActiveTab(); props.changeActiveArtworkIndex(index) }}>
                <div className="col-4 col-md-2">{artwork.ArtworkId}</div>
                <div className="col-4 col-md-2">v{artwork.Version}</div>
                <div className="col-2 d-none d-md-inline-block">{ARTWORK_TYPES_TITLE[artwork.ArtworkType].title}</div>
                <div className="col-2 col-md-5 col-lg-5 px-0">
                    <div className="row">
                        <div className="col-2">
                            <div className={`circle active ${(artwork.ArtworkStatus === ARTWORK_STATUSES.ClientRejected) || (artwork.ArtworkStatus === ARTWORK_STATUSES.ProofSuccess) || (warningText && JobStatus === JOB_STATUSES.WaitingClientReview) ? 'expire' : ''}`}></div>
                        </div>
                        <div className={`col-10 d-none d-md-inline-block ${(artwork.ArtworkStatus === ARTWORK_STATUSES.ClientRejected) || (artwork.ArtworkStatus === ARTWORK_STATUSES.ProofSuccess) || (warningText && JobStatus === JOB_STATUSES.WaitingClientReview) ? 'expire' : ''}`}>
                            {(warningText && JobStatus === JOB_STATUSES.WaitingClientReview) || (artwork.ArtworkStatus === ARTWORK_STATUSES.ProofSuccess) ? WARNING_NOTIFICATIONS.awaitingApproval : ARTWORK_STATUSES_TITLE[artwork.ArtworkStatus].title}

                            {artwork.activeWorkCell && (
                                <div className="order-details text-xs">{artwork.activeWorkCell}</div>
                            )}
                        </div>

                    </div>
                </div>
                <div className="col-1 d-flex justify-content-start align-items-baseline">
                    <button type="button" className={`button-edit ${artwork.ArtworkStatus === ARTWORK_STATUSES.ClientRejected || (artwork.ArtworkStatus === ARTWORK_STATUSES.ProofSuccess) ? 'expire' : ''}`}>
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.3779 0.0263672C4.96379 0.0263672 0.559082 4.41927 0.559082 9.81883C0.559082 15.2184 4.96379 19.6113 10.3779 19.6113C15.7919 19.6113 20.1967 15.2184 20.1967 9.81883C20.1967 4.41927 15.7919 0.0263672 10.3779 0.0263672ZM10.3779 14.7151V10.7981H5.46848V8.83959H10.3779V4.9226L15.2873 9.81883L10.3779 14.7151Z" fill="var(--faded)" />
                        </svg>
                    </button>
                </div>
            </div>
        )
    })
}

const renderSlider = (props) => {
    const { jobs, activeJobIndex } = props;
    const { warningText } = props.jobData;

    const renderCircle = () => {
        return jobs.map((job, index) => <div className={`circle ${job.warningText ? 'expire' : ''} ${activeJobIndex === index && !warningText ? 'active' : ''} `} key={index} onClick={() => props.changeActiveJobIndex(index)}></div>)
    }

    const onChangeForward = () => {
        if (activeJobIndex < jobs.length - 1) {
            props.changeActiveJobIndex(activeJobIndex + 1);
        }
    }

    const onChangeBackward = () => {
        if (activeJobIndex > 0) {
            props.changeActiveJobIndex(activeJobIndex - 1);
        }
    }

    return (
        <div className="row d-flex justify-content-between align-items-center">
            <button type="button" className="button-edit" onClick={() => onChangeBackward()}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.88436 20.2539C15.2984 20.2539 19.7031 15.861 19.7031 10.4614C19.7031 5.06189 15.2984 0.668993 9.88436 0.668992C4.4703 0.668992 0.0656008 5.06189 0.0656003 10.4614C0.0655998 15.861 4.4703 20.2539 9.88436 20.2539ZM9.88436 5.56522L9.88436 9.4822L14.7937 9.4822L14.7937 11.4407L9.88436 11.4407L9.88436 15.3577L4.97498 10.4614L9.88436 5.56522Z" fill="var(--faded)" />
                </svg>
            </button>
            <div className="slider">
                <div className="row d-flex justify-content-center">
                    {renderCircle()}
                </div>
            </div>
            <button type="button" className="button-edit" onClick={() => onChangeForward()}>
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.3779 0.0263672C4.96379 0.0263672 0.559082 4.41927 0.559082 9.81883C0.559082 15.2184 4.96379 19.6113 10.3779 19.6113C15.7919 19.6113 20.1967 15.2184 20.1967 9.81883C20.1967 4.41927 15.7919 0.0263672 10.3779 0.0263672ZM10.3779 14.7151V10.7981H5.46848V8.83959H10.3779V4.9226L15.2873 9.81883L10.3779 14.7151Z" fill="var(--faded)" />
                </svg>
            </button>
        </div>
    )
}

const OrderJob = (props) => {
    const { activeJobIndex, jobs } = props;
    const { JobId, JobName, ProductName, Quantity, FinishedSizeWidth, FinishedSizeHeight, ColorFront, ColorBack, ColorThroughout, Orientation, Binding,
        TextPaper, PaperType, LaminationFront, LaminationBack, Pages, CoverColorFront, CoverColorBack, CoverColour, CoverPaper, CoverPaperType, LaminationCoverFront, LaminationCoverBack, LaminationCover,
        TotalPrice, DeliveryCost, artworks, JobStatus, warningText, ClientJobReference, IsComplete } = props.jobData;
    const frontBackColour = ProductName && PRODUCTS_COLOURS_FRONT_BACK.includes(ProductName) ? true : false;
    const frontBackFinishing = ProductName && PRODUCTS_FINISHING_FRONT_BACK.includes(ProductName) ? true : false;
    const bindingView = ProductName && PRODUCT_BY_BINDING.find(element => element.productName === ProductName) ? true : false;
    const checkCover = ProductName && PRODUCTS_ADD_COVER.includes(ProductName) ? true : false;
    const frontBackCover = ProductName && PRODUCTS_FRONT_BACK_COVER.includes(ProductName) ? true : false;

    return (
        <section className="order-job col-12 col-lg-10 offset-lg-1 mt-5">
            <div className="row">
                <div className="col-12 col-md-5 col-lg-5 px-0 mb-3">
                    <div className="col-10 offset-2 col-xl-8 mb-3">
                        <div className="container-fluid">
                            {renderSlider(props)}
                        </div>
                    </div>
                    <div className="col-12 id">
                        <div className="row">
                            <div className="col-2 px-0 d-flex justify-content-end">
                                {warningText ? <div className="circle active expire"></div> : null}
                            </div>
                            <span className="col-10"> Job# {JobId}</span>
                        </div>
                    </div>
                    <div className="col-10 offset-2 quote mt-2">{JobName ? JobName : null}</div>
                </div>
                <div className="col-12 col-md-7 px-0 px-md-5 mb-4 order-first order-md-last">
                    <div className="col-12">
                        <BarOrderStatus isComplete={IsComplete} status={JobStatus} orderStatus={props.orderStatus} warningText={warningText} view={VIEW_BAR_STATUS.job} title={JOB_STATUSES_TITLE} statusBar={JOB_STATUSES_BAR} />
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-5 mb-3">
                    <div className="row">
                        <div className="col-10 offset-2 job-details my-2">
                            <div className="row">
                                {ProductName ? <p className="col-12">Product: {ProductName}</p> : null}
                                <p className="col-12">Your Reference: {ClientJobReference ? ClientJobReference : null}</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="data col-8 offset-2 col-md-6 offset-md-2">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row mt-1">
                                                <p className="col-12">Quantity:</p>
                                                <p className="col-12 mt-1 value">{Quantity}</p>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row mt-1">
                                                <p className="col-12">Size:</p>
                                                <p className="col-12 mt-1 value">{FinishedSizeWidth} x {FinishedSizeHeight}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {frontBackCover ?
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="row mt-1">
                                                    <p className="col-12">Binding:</p>
                                                    <p className="col-12 mt-1 value">{Binding}</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="row mt-1">
                                                    <p className="col-12">Printed Pages:</p>
                                                    <p className="col-12 mt-1 value">{Pages}</p>
                                                </div>
                                            </div>
                                        </div>
                                        : null}

                                    {!frontBackCover && bindingView ?
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="row mt-1">
                                                    <p className="col-12">Binding:</p>
                                                    <p className="col-12 mt-1 value">{Binding}</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="row mt-1">
                                                    <p className="col-12">Printed pages:</p>
                                                    <p className="col-12 mt-1 value">{Pages}</p>
                                                </div>
                                            </div>
                                        </div>
                                        : null}

                                    {checkCover ?
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="row mt-1">
                                                    <p className="col-12">Orientation:</p>
                                                    <p className="col-12 mt-1 value">{Orientation}</p>
                                                </div>
                                            </div>
                                        </div> : null}
                                </div>
                                <div className="col-10 offset-1 col-md-8 mt-3">
                                    <div className="row">
                                        <div className="col-1 col-md-2 px-0 px-md-3 mt-3 d-flex justify-content-end justify-content-md-center align-items-baseline">
                                            {checkCover ? <img src={require('../../assets/img/quotes/job-icon.svg')} alt="icon" className="cover-icon" /> : null}
                                        </div>
                                        <div className="col-10 col-md-8 offset-md-0 px-md-0 data">

                                            {frontBackColour ?
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12">{checkCover ? <span>Text </span> : null} Colour: (front)</p>
                                                            <p className="col-12 mt-1 value">{ColorFront}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12">{checkCover ? <span>Text </span> : null} Colour: (back)</p>
                                                            <p className="col-12 mt-1 value">{ColorBack}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="row mt-1">
                                                            <p className="col-12">{checkCover ? <span>Text </span> : null}  Colour: (throughout)</p>
                                                            <p className="col-12 mt-1 value">{ColorThroughout}</p>
                                                        </div>
                                                    </div>
                                                </div>}

                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="row mt-1">
                                                        <p className="col-12 pr-0">{checkCover ? <span>Text </span> : null} Paper weight:</p>
                                                        <p className="col-12 mt-1 value">{TextPaper}</p>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row mt-1">
                                                        <p className="col-12">{checkCover ? <span>Text </span> : null} Paper type:</p>
                                                        <p className="col-12 mt-1 value">{PaperType}</p>
                                                    </div>

                                                </div>
                                            </div>


                                            {frontBackFinishing ?
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12 col-md-10">{checkCover ? <span>Text </span> : null} Finishing: (front)</p>
                                                            <p className="col-12 col-md-10 mt-1 value">{LaminationFront}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12 col-md-10">{checkCover ? <span>Text </span> : null} Finishing: (back)</p>
                                                            <p className="col-12 col-md-10 mt-1 value">{LaminationBack}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {checkCover ?
                            <React.Fragment>
                                <div className="col-10 offset-1 col-md-8 mt-3">
                                    <div className="row">
                                        <div className="col-1 col-md-2 px-0 px-md-3 mt-3 d-flex justify-content-end justify-content-md-center align-items-baseline">
                                            <img src={require('../../assets/img/quotes/job-cover-icon.svg')} alt="icon" className="cover-icon" />
                                        </div>
                                        <div className="col-10 col-md-8 px-md-0 data">
                                            {frontBackCover ?
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12">Cover Colour: (front)</p>
                                                            <p className="col-12 mt-1 value">{CoverColorFront}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12">Cover Colours: (back)</p>
                                                            <p className="col-12 mt-1 value">{CoverColorBack}</p>
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="row mt-1">
                                                            <p className="col-12">Cover Colour: (throughout)</p>
                                                            <p className="col-12 mt-1 value">{CoverColour}</p>
                                                        </div>
                                                    </div>
                                                </div>}
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="row mt-1">
                                                        <p className="col-12 pr-0">Cover paper weight</p>
                                                        <p className="col-12 mt-1 value">{CoverPaper}</p>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row mt-1">
                                                        <p className="col-12">Cover paper type</p>
                                                        <p className="col-12 mt-1 value">{CoverPaperType}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {frontBackCover ?
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12 pr-0">Cover Finishing: (front)</p>
                                                            <p className="col-12 mt-1 value">{LaminationCoverFront}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12 pr-0">Cover Finishing: (back)</p>
                                                            <p className="col-12 mt-1 value">{LaminationCoverBack}</p>
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="row mt-1">
                                                            <p className="col-12 pr-0">Cover Finishing:</p>
                                                            <p className="col-12 mt-1 value">{LaminationCover}</p>
                                                        </div>
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                            : null}
                        {TotalPrice ? (
                            <div className="col-11 col-md-10 offset-1 offset-md-2 px-md-0 job-details my-4">
                                <p className="col-12">Unit price: <span className="price">£{DeliveryCost}</span></p>
                                <p className="col-12">Total: <span className="order-price">£{Math.round(TotalPrice)}</span></p>
                            </div>
                        ) : null}
                    </div>
                </div>

                <div className="col-12 mb-3 col-md-7">
                    <div className="container px-md-3">
                        <div className="col-12 mt-0 mt-md-3">
                            <div className="row">
                                <div className="col-12 mb-3 mt-md-3">
                                    <p className="col-12 title">Artworks</p>
                                </div>
                                <div className="table col-12 px-md-3">
                                    <div className="col-12 thead">
                                        <div className="row mb-3">
                                            <div className="col-4 col-md-2">Id #</div>
                                            <div className="col-4 col-md-2">Version</div>
                                            <div className="col-2 d-none d-md-inline-block">Type</div>
                                            <div className="col-4 col-md-5 col-lg-4 px-0 d-none d-md-inline-block">
                                                <div className="col-10 px-2 float-right">Status</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        {renderArtworkList(artworks, props)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    );
}

export default OrderJob;